import { UserLoginStatus } from "../Enums/Enums";
import {
    IApplication,
    IBatch,
    ICompany,
    IFeature,
    IReport,
    IRole,
    IUserGroup,
    IUserPreferences,
} from "./Models";

export interface IUser {
  readonly userID: number;
  company: ICompany;
  preferences: IUserPreferences;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  profileImage: string;
  userName: string;
  isActive: boolean;
  expireDateTime: Date;
  expireDateTimeFriendly: string;
  createdDateTime: Date;
  readonly createdByUserID: number;
  readonly isBuxtonUser: boolean;
  title: string;
  canEmail: boolean;
  readonly passwordHash: string;
  expirePasswordDateTime: Date;
  groups: IUserGroup[];
  oktaGroups: string[];
  oktaUserID: string;
  applications: IApplication[];
  readonly loginDates: Date[];
  franchiseStoresCount: number;
  franchiseTerritoriesCount: number;
  lastLoginFriendly: string;
  features: IFeature[];
  roles: IRole[];
  reports: IReport;
  batches: IBatch[];
  personaID: number;
  expireAuthTokenDate: any;
  expireSessionDate: any;
  loginStatus: UserLoginStatus;
  readonly totalLoginCount: number;
  readonly totalLoginCountCurrentYear: number;
  readonly totalLoginCountPreviousYear: number;
  readonly totalLoginCountTwoYearsAgo: number;
  readonly serverVerified: boolean;
  isAdmin: boolean;
  isFranchisee: boolean;
  isRegularUser: boolean;
  readonly maxSessionCount: number;
  readonly lastKnownIP: string;
  shouldLogActions: boolean;
  fullName: string;
  isSetup: boolean;
  identity: any /* interface<IIdentity> */;
  authorizedGeographyWKT: string;
  /** Used when a user chooses to upload a "Logo" when they share a GPS report. */
  shareImage: string;
}
